export default "__VITE_ASSET__e91235d6__"